import React from 'react'
import CountUp from './CountUp'
import styles from './index.module.css'
import srilankanMap from '../../assets/srilankan_map.png'

const BusinessGrowSection = () => {
  return (
    <div className={styles.mainDiv}>
        <div className={styles.innerDiv}>
        
            <div className={styles.cardsContainer}>
                <div className={`${styles.card} ${styles.trustedClientsCard}`}>
                    <div className={styles.cardContent}>
                        <div className={styles.number}>
                            <CountUp target={50} duration={1000} />
                            <span>+</span>
                        </div>
                        <div className={`${styles.label} ${styles.trustedClientsLabel}`}>TRUSTED CLIENTS</div>
                        <div className={styles.description}>
                          Unlock your business's potential with our point of sale system. Streamline operations, enhance customer experiences, and boost sales with powerful tools designed for your unique needs.
                        </div>
                    </div>
                    <div className={styles.cardImage}>
                        <img src={srilankanMap} alt="Sri Lanka Map" className={styles.mapImage} />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default BusinessGrowSection
